import { createComponent as _$createComponent } from "@opentui/solid";
import { createTextNode as _$createTextNode } from "@opentui/solid";
import { insertNode as _$insertNode } from "@opentui/solid";
import { insert as _$insert } from "@opentui/solid";
import { setProp as _$setProp } from "@opentui/solid";
import { createElement as _$createElement } from "@opentui/solid";
import { TextAttributes } from "@opentui/core";
import { For } from "solid-js";
import { useTheme, tint } from "@tui/context/theme";
import { logo, marks } from "@/cli/logo";

// Shadow markers (rendered chars in parens):
// _ = full shadow cell (space with bg=shadow)
// ^ = letter top, shadow bottom (▀ with fg=letter, bg=shadow)
// ~ = shadow top only (▀ with fg=shadow)
const SHADOW_MARKER = new RegExp(`[${marks}]`);
export function Logo() {
  const {
    theme
  } = useTheme();
  const renderLine = (line, fg, bold) => {
    const shadow = tint(theme.background, fg, 0.25);
    const attrs = bold ? TextAttributes.BOLD : undefined;
    const elements = [];
    let i = 0;
    while (i < line.length) {
      const rest = line.slice(i);
      const markerIndex = rest.search(SHADOW_MARKER);
      if (markerIndex === -1) {
        elements.push((() => {
          var _el$ = _$createElement("text");
          _$setProp(_el$, "fg", fg);
          _$setProp(_el$, "attributes", attrs);
          _$setProp(_el$, "selectable", false);
          _$insert(_el$, rest);
          return _el$;
        })());
        break;
      }
      if (markerIndex > 0) {
        elements.push((() => {
          var _el$2 = _$createElement("text");
          _$setProp(_el$2, "fg", fg);
          _$setProp(_el$2, "attributes", attrs);
          _$setProp(_el$2, "selectable", false);
          _$insert(_el$2, () => rest.slice(0, markerIndex));
          return _el$2;
        })());
      }
      const marker = rest[markerIndex];
      switch (marker) {
        case "_":
          elements.push((() => {
            var _el$3 = _$createElement("text");
            _$insertNode(_el$3, _$createTextNode(` `));
            _$setProp(_el$3, "fg", fg);
            _$setProp(_el$3, "bg", shadow);
            _$setProp(_el$3, "attributes", attrs);
            _$setProp(_el$3, "selectable", false);
            return _el$3;
          })());
          break;
        case "^":
          elements.push((() => {
            var _el$5 = _$createElement("text");
            _$insertNode(_el$5, _$createTextNode(`▀`));
            _$setProp(_el$5, "fg", fg);
            _$setProp(_el$5, "bg", shadow);
            _$setProp(_el$5, "attributes", attrs);
            _$setProp(_el$5, "selectable", false);
            return _el$5;
          })());
          break;
        case "~":
          elements.push((() => {
            var _el$7 = _$createElement("text");
            _$insertNode(_el$7, _$createTextNode(`▀`));
            _$setProp(_el$7, "fg", shadow);
            _$setProp(_el$7, "attributes", attrs);
            _$setProp(_el$7, "selectable", false);
            return _el$7;
          })());
          break;
      }
      i += markerIndex + 1;
    }
    return elements;
  };
  return (() => {
    var _el$9 = _$createElement("box");
    _$insert(_el$9, _$createComponent(For, {
      get each() {
        return logo.left;
      },
      children: (line, index) => (() => {
        var _el$0 = _$createElement("box"),
          _el$1 = _$createElement("box"),
          _el$10 = _$createElement("box");
        _$insertNode(_el$0, _el$1);
        _$insertNode(_el$0, _el$10);
        _$setProp(_el$0, "flexDirection", "row");
        _$setProp(_el$0, "gap", 1);
        _$setProp(_el$1, "flexDirection", "row");
        _$insert(_el$1, () => renderLine(line, theme.textMuted, false));
        _$setProp(_el$10, "flexDirection", "row");
        _$insert(_el$10, () => renderLine(logo.right[index()], theme.text, true));
        return _el$0;
      })()
    }));
    return _el$9;
  })();
}